export default "__VITE_ASSET__807eeb57__"